module.exports = __webpack_public_path__ + "media/images/february23/february23-template-am-75ba3a090abfb4c562d99d5100ea3af4.png";